import * as React from 'react';
import { NAVIGATION_CATEGORIES} from '../../router/routes';
import { NavigationCategoryButton } from './NavigationCategoryButton';

export const Navigation: React.FC<Props> = (props) =>
<nav className={props.ismobile ? 'Vnav': "Hnav"}>
    {NAVIGATION_CATEGORIES.map(c =>
        <NavigationCategoryButton
            key = {c.categoryName}
            category = {c} 
        />
    )}
</nav>



interface Props { 
    ismobile:boolean
}

